import { TextField } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledTextField = styled(TextField)({
  background: "white"
})

const EmailBoxInput = ({ values, handleBlur, handleChange, touched, errors, t }) => {
  return (
    <StyledTextField
      placeholder={t("global.enter_email", "Enter email")}
      autoComplete="off"
      fullWidth
      id="emailRecipient"
      value={values.emailRecipient}
      onChange={handleChange}
      onBlur={handleBlur}
      error={touched.emailRecipient && errors.emailRecipient ? true : false}
      helperText={touched.emailRecipient && errors.emailRecipient ? errors.emailRecipient : null}
      variant="outlined"
      InputProps={{ disableUnderline: true }}
    />
  )
}

export default EmailBoxInput
